import { useApiClient } from '@cldsystems/ws-api-client';
import { useMutation } from '@tanstack/react-query';

import { postReviewUploadImage } from '@/services/review-images';

const useReviewUploadImageMutation = () => {
  const { httpClient } = useApiClient();

  return useMutation({
    mutationKey: ['webshopReviewUploadImage'],
    mutationFn: async ({
      id,
      version,
      files,
    }: {
      id: string;
      version: number | string;
      files: File[];
    }) => {
      return postReviewUploadImage(httpClient, { id, version, files });
    },
  });
};

export default useReviewUploadImageMutation;
